<template>
  <div class="mit-volumes-explore pa-5">
    <BaseMitLoading :show="loading" :fullscreen="false"/>
    <MitTreeView class="test1" v-if="volumes.length > 0" title="Volumes" :items="volumes" @click:node="selectNode" :openNodes="openNodes" :selectedNode="defaultSelectedNode">
      <template v-slot:title="{ titleText }">
          <v-radio-group dense row v-model="treeType" mandatory @change="treeTypeChanged">
            <v-radio label="Grouped" value="grouped"></v-radio>
            <v-radio label="By Host" value="host"></v-radio>
          </v-radio-group>
      </template>
      <template v-slot:activeNodeDetails="{ node }">
          <!-- <v-toolbar-title>{{node.name}}</v-toolbar-title>
          <v-spacer></v-spacer> -->
          <!-- SEARCH - disable search if totalItems is provided since this means we are using server side data-->
          <v-skeleton-loader v-if="!loading && (loadingActivity || loadingUser || loadingTimeSeries)" v-bind="attrs" type="image, image"></v-skeleton-loader>
          <div v-else>
              <MitVolumesAnalytics v-if="currentNode && topActivityChart.data && topUserChart.data" :icon="currentNode.ui.icon" :title="currentNode.name" :subTitle="currentNode.id" :dataTopActivity="topActivityChart" :dataTopUsers="topUserChart"/>
              <MitVolumesAnalyticsTime v-if="currentNode && selectedNodeIsLeaf && timeseriesChart.datasets" :icon="currentNode.ui.icon" :title="currentNode.name" :subTitle="currentNode.id" :timeseriesActivity="timeseriesChart"/>
          </div>
          <v-skeleton-loader v-if="!loading && loadingList" v-bind="attrs" type="table-heading, table-tbody"></v-skeleton-loader>
          <div v-else>
              <BaseMitDataTable
                title=""
                :page="listPaging.page"
                :pageSize="listPaging.pageSize"
                :totalItems="listPaging.totalItems"
                :editable="false"
                :headers="listHeaders"
                :items="listItems"
              >
              </BaseMitDataTable>
           </div>
      </template>
    </MitTreeView>
  </div>
</template>

<script>
import moment from 'moment';

import MitUnitsService from '../services/MitUnitsService.js';
let currentUnit = MitUnitsService.getUserVolumeUnit();
import MitStorageService from '../services/MitStorageService.js';
// import BaseMitTreeView from '../../base/components/BaseMitTreeView.vue';
import MitTreeView from './MitTreeView.vue';
import MitVolumesAnalytics from './MitVolumesAnalytics.vue';
import MitVolumesAnalyticsTime from './MitVolumesAnalyticsTime.vue';
import BaseMitDataTable from '../../base/components/BaseMitDataTable.vue';
import BaseMitLoading from '../../base/components/BaseMitLoading.vue';

export default {
  name: 'MitVolumesList',
  components: {
    BaseMitLoading,
    MitTreeView,
    BaseMitDataTable,
    MitVolumesAnalytics,
    MitVolumesAnalyticsTime
  },
  props: {
  },
  data: function() {
    return {
      loading:false,
      loadingList:false,
      loadingActivity:false,
      loadingUser:false,
      loadingTimeSeries:false,
      search: '',
      options:{},
      currentNode:null,
      defaultSelectedNode: [],//selected node
      openNodes: [],//open nodes
      treeType:'grouped',
      volumes:[],
      listItems:[],
      listHeaders:[
          {text: 'Mount Point',sortable: true,value: 'mountPoint', divider: true},
          // {text: 'Host',sortable: true,value: 'host'},
          // {text: 'Owner',sortable: false,value: 'owner'},
          // {text: 'Mount Point',sortable: false,value: 'mountPoint'},
          // {text: 'External Id',sortable: true,value: 'externalId'},
          {text: 'Available ('+currentUnit.unit+')',sortable: false, value: 'sizeConverted.available'},
          {text: 'Used ('+currentUnit.unit+')',sortable: false, value: 'sizeConverted.used'},
          {text: 'Used By Snapshots ('+currentUnit.unit+')',sortable: false, value: 'sizeConverted.usedBySnapshots'},
          {text: 'Compression Ratio',sortable: false, value: 'compressRatio'}
          // {text: 'Size Used (GB)',sortable: false,value: 'currentState_GB.used'},
          // {text: 'Size Total (GB)',sortable: false,value: 'currentState_GB.total'},
          // {text: 'Last Updated',sortable: false,value: 'dates_local.lastEditedDt'},
          // {text: 'Edit Date',sortable: true,value: 'dates_local.lastEditedDt'}
      ],
      listPaging:{
        page:1,
        pageSize:-1,
        totalItems:0
      },
      topActivityChart: {
          data:null,
          dataLabels:null,
          title:'Top 5 Activity - Data Written (sum each day)',
          labelX:'',
          labelY:'Data ('+currentUnit.unit+')'
      },
      topUserChart: {
          data:null,
          dataLabels:null,
          title:'Top 5 Groups - Data Used ('+currentUnit.unit+')',
          labelX:'',
          labelY:'Data ('+currentUnit.unit+')'
      },
      selectedNodeIsLeaf: false,
      timeseriesChart: {
          datasets:null,
          title:'Data Used ('+currentUnit.unit+')',
          labelX:'',
          labelY:'Data ('+currentUnit.unit+')'
      }
    }
  },
  created() {
      this.currentNodePath = this.$route.path.substring('/explore/storage/'.length-1);
      if(this.$route.query.view === 'host'){
          this.treeType = 'host'
          //This is a HACK, because the id for the host nodes doesn't start with a /
          //The correct fix would be to make the ids consistent from grouped and hosted.
          this.currentNodePath = this.currentNodePath.substring(1);
      }
      this.refreshData(this.treeType)
  },
  mounted(){
  },
  methods : {
    updateUrl(path, treeType){
        //Avoid navigation to a url we are already on, this will cause an error.
        if(this.currentNodePath !== path){
            this.currentNodePath = path;

            let url = {
                path: '/explore/storage/'+ path,
                query: { view: treeType }
            }
            if(treeType === 'grouped')
                delete url.query

            this.$router.push(url);
        }

    },
    treeSelectNode(node, targetNodePath){
        this.openNodes.push(node);
        if(node.id === targetNodePath){
            this.defaultSelectedNode.push(node);
        }
        else{
            if(node.children){
              for(let x = 0; x < node.children.length; x++){
                  if(targetNodePath.indexOf(node.children[x].id) > -1){
                      this.treeSelectNode(node.children[x], targetNodePath)
                  }
              }
            }
        }
    },
    selectNode(node){
        if(node){ //make sure there is a proper node here, could be null
            this.currentNode = node;
            this.updateUrl(node.id, this.treeType);

            this.selectedNodeIsLeaf = node.children.length === 0;

            this.topActivityChart.data = null;
            this.topUserChart.data = null;
            this.timeseriesChart.data = [];

            if(this.selectedNodeIsLeaf){
                this.getNodeAnalyticsTimeseries(this.treeType, node.getChildrenOptions);
            }
            else{
                this.getLeafNodeAnalyticsActivity(this.treeType, node.getChildrenOptions);
                this.getLeafNodeAnalyticsUser(this.treeType, node.getChildrenOptions)
            }

            this.getLeafNodeList(this.treeType, node.getChildrenOptions, this.selectedNodeIsLeaf);
        }
    },
    treeTypeChanged (){
        this.updateUrl('', this.treeType);//we switchted the type so reset back to root path.
        this.refreshData(this.treeType)
    },
    refreshData(type, pagination, options){
      this.loading = true;
      MitStorageService.requestGetVolumesExplore((type==='grouped'))
        .then((data) => {
          this.loading = false;

          this.volumes = data.tree;

          if(this.currentNodePath.length > 1){
              this.treeSelectNode(this.volumes[0], this.currentNodePath);
          }

        })
        .catch((error) => {
          this.loading = false;
          console.log('An error occurred trying to get keys list', error);
        });
    },
    getLeafNodeList(type, options, isLeafNode){
      this.loadingList = true;

      //if it is a leaf node don't search for sub nodes by adding a /%
      let path = (isLeafNode) ? options.path : options.path+'/%';

      MitStorageService.requestGetLeafVolumes({
          mountPoint: path,
          host: (type === 'grouped') ? null : options.host
      })
        .then((data) => {
          this.loadingList = false;

          this.listItems = data.volumes;
          this.listPaging.totalItems = data.total;
        })
        .catch((error) => {
          this.loadingList = false;
          console.log('An error occurred trying to get keys list', error);
        });
    },
    getNodeAnalyticsTimeseries(type, options){
      this.loadingTimeSeries = true;

      this.timeseriesChart.data = null;

      MitStorageService.requestGetVolumesAnalyticsTimeSeries({
          mountPoint: options.path,
          host: (type === 'grouped') ? null : options.host
      })
        .then((data) => {
          this.loadingTimeSeries = false;
          this.timeseriesChart.datasets = [];

          let dataset = null;
          for(let x = 0; x < data.volumes.length; x++){
              let dataset = {
                  label:data.volumes[x][0].fullPath,
                  data:[]
              };
              for(let y = 0; y < data.volumes[x].length; y++){
                  dataset.data.push({x:data.volumes[x][y].datesLocal.createDt,
                                     y:data.volumes[x][y].sizeConverted.used});
              }
              this.timeseriesChart.datasets.push(dataset);
          }
        })
        .catch((error) => {
          this.loadingTimeSeries = false;
          console.log('An error occurred trying to get keys list', error);
        });
    },
    getLeafNodeAnalyticsActivity(type, options){
      this.loadingActivity = true;

      this.topActivityChart.data = null;

      MitStorageService.requestGetVolumesAnalyticsActivity({
          mountPoint: options.path,
          host: (type === 'grouped') ? null : options.host,
          limit: 5,
          orderBy: 'size_used'
      })
        .then((data) => {
          this.loadingActivity = false;

          this.topActivityChart.data = [];
          this.topActivityChart.dataLabels = [];
          data.analytics.forEach((item, index, arr)=>{
              this.topActivityChart.data.push(item.sizeConverted.sizeUsed);
              this.topActivityChart.dataLabels.push(item.fullPath);
          });

        })
        .catch((error) => {
          this.loadingActivity = false;
          console.log('An error occurred trying to get keys list', error);
        });
    },
    getLeafNodeAnalyticsUser(type, options){
      this.loadingUser = true;
      this.topUserChart.data = null;

      MitStorageService.requestGetVolumesAnalyticsTopUsers({
          mountPoint: options.path,
          host: (type === 'grouped') ? null : options.host,
          limit: 5,
          orderBy: 'size_used'
      })
        .then((data) => {
          this.loadingUser = false;
          this.topUserChart.data = [];
          this.topUserChart.dataLabels = [];
          data.analytics.forEach((item, index, arr)=>{
              this.topUserChart.data.push(item.sizeConverted.sizeUsed);
              this.topUserChart.dataLabels.push(item.pi || 'unknown');
          });

        })
        .catch((error) => {
          this.loadingUser = false;
          console.log('An error occurred trying to get keys list', error);
        });
    }
  }
}
</script>

<style lang="scss" scoped>
    // make the tree fit in the window minus the toolbar and things above
    .mit-volumes-explore {
        :deep(.scroll){
          max-height: calc(100vh - 380px);
          overflow-y: scroll;
        }
    }
    .mit-progress-overlay {
      height:100vh;
    }
    .mit-progress {
      display: flex;
      align-items: center;
      justify-content: center;
    }

</style>
